var map = {
	"./arrowDown.svg": 11970,
	"./arrowLeftBlue.svg": 33142,
	"./arrowLeftBlueGreen.svg": 16841,
	"./arrowLeftGreen.svg": 58054,
	"./border.svg": 62475,
	"./chip.svg": 70745,
	"./chipClipped.svg": 80657,
	"./circleBlue.svg": 86450,
	"./cricleGreen.svg": 40616,
	"./curlBlue.svg": 15729,
	"./curlDownGreen.svg": 13692,
	"./curlUpGreen.svg": 16612,
	"./curlyArrowDownGreen.svg": 97286,
	"./curlyArrowLeftGreen.svg": 41891,
	"./disk.svg": 68299,
	"./flash.svg": 41620,
	"./ropeGreen.svg": 37335,
	"./whirlBlue.svg": 64482,
	"./whirlWhiteBlue.svg": 20242,
	"./wiggleDownGreen.svg": 92291,
	"./wiggleUpGreen.svg": 65619,
	"website/contentElements/ornament/images/arrowDown.svg": 11970,
	"website/contentElements/ornament/images/arrowLeftBlue.svg": 33142,
	"website/contentElements/ornament/images/arrowLeftBlueGreen.svg": 16841,
	"website/contentElements/ornament/images/arrowLeftGreen.svg": 58054,
	"website/contentElements/ornament/images/border.svg": 62475,
	"website/contentElements/ornament/images/chip.svg": 70745,
	"website/contentElements/ornament/images/chipClipped.svg": 80657,
	"website/contentElements/ornament/images/circleBlue.svg": 86450,
	"website/contentElements/ornament/images/cricleGreen.svg": 40616,
	"website/contentElements/ornament/images/curlBlue.svg": 15729,
	"website/contentElements/ornament/images/curlDownGreen.svg": 13692,
	"website/contentElements/ornament/images/curlUpGreen.svg": 16612,
	"website/contentElements/ornament/images/curlyArrowDownGreen.svg": 97286,
	"website/contentElements/ornament/images/curlyArrowLeftGreen.svg": 41891,
	"website/contentElements/ornament/images/disk.svg": 68299,
	"website/contentElements/ornament/images/flash.svg": 41620,
	"website/contentElements/ornament/images/ropeGreen.svg": 37335,
	"website/contentElements/ornament/images/whirlBlue.svg": 64482,
	"website/contentElements/ornament/images/whirlWhiteBlue.svg": 20242,
	"website/contentElements/ornament/images/wiggleDownGreen.svg": 92291,
	"website/contentElements/ornament/images/wiggleUpGreen.svg": 65619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10375;